'use client'

import { ReactNode, useEffect } from "react"
// import PageLayout from "./_config"
import PageLayout from "@/util/board_config"
import { usePathname, redirect, useRouter, useSearchParams  } from "next/navigation"
import { tabsType } from "@/type/page"


import BoardView from "@/components/board/detail_v2"
import VerifiedView from "./view"
import { mobileModel } from "react-device-detect"
import { setNeedRefresh } from "@/type/historyStack"; 

export interface TabWithParam extends tabsType {
  param: Record<string, any>
}
export default function Layout({ children }: { children: ReactNode }) {
    const pathname = usePathname()
    const basePath = pathname.split("/").slice(0, 3).join("/")
    const router = useRouter();

    
    const perPage = mobileModel ? 10 : 20

    const pageConfig: Record<string, { 
        apiUrlBase: string; 
        responseKey: string; 
        tabs_path: TabWithParam[] 
        ViewComponent: React.ComponentType<any>
        isSearch:boolean;
    }> = {
        "/notice/": {
            apiUrlBase: "/api/notice/list/",
            responseKey: "objects",
            tabs_path: [
                { name: "공지사항", path: "/notice/", param: {page:1 } },
            ],
            ViewComponent: VerifiedView,
            isSearch: true
        },



    }

    const config = pageConfig[basePath] || { apiUrlBase: "", responseKey: "posts_list", tabs_path: [] }
    const { apiUrlBase, responseKey, tabs_path, ViewComponent, isSearch } = config

    // useEffect(() => {
    //     if(pathname == "/sportsanalysis/"){
    //         setNeedRefresh(true)
    //         router.replace("/sportsanalysis");
    //     }
    // }, [pathname, router])

    return (
        <PageLayout apiUrlBase={apiUrlBase}
                    responseKey={responseKey} 
                    defaultCate={1}
                    tabs_path={tabs_path}
                    editCategories={[2, 3]}
                    ViewComponent={ViewComponent}
                    isSearch={isSearch}
                    perPage={perPage} >
            {children}
        </PageLayout>
    )
}
